<template>
    <div class="creatives-option">
        <div class="creatives-option__header">
            <h3 class="creatives-option__title">Креативы</h3>
            <div class="creatives-option__actions">
                <img
                    v-if="!localSelected.length"
                    alt="red_star"
                    class="is-empty"
                    src="/images/red_star.svg"
                />
                <button class="btn-toggle" @click="toggleAll">
                    {{ isAllSelected ? 'Очистить' : 'Выбрать все' }}
                </button>
            </div>
        </div>

        <div class="creatives-option__grid">
            <div v-for="creative in creatives" :key="creative.id" class="creative-card">
                <div class="creative-card__preview">
                    <img v-if="creative.type === 'picture'" :src="creative.url" alt="preview" />
                    <video v-else-if="creative.type === 'video'" :src="creative.url" muted loop></video>
                    <input
                        type="checkbox"
                        class="creative-card__checkbox"
                        :value="creative.id"
                        v-model="localSelected"
                    />
                </div>
                <div class="creative-card__info">
                    <div class="creative-card__name">
                        {{ creative.name }}
                    </div>
                    <div class="creative-card__size">
                        ID: {{ creative.id }} &nbsp; · &nbsp;
                        <img src="/images/size.svg" alt="size" />
                        {{ creative.width }} × {{ creative.height }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreativesOption',
    props: {
        creatives: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            localSelected: this.modelValue,
        };
    },
    computed: {
        isAllSelected() {
            return this.creatives.length > 0 && this.localSelected.length === this.creatives.length;
        },
    },
    methods: {
        toggleAll() {
            if (this.isAllSelected) {
                this.localSelected = [];
            } else {
                this.localSelected = this.creatives.map((c) => c.id);
            }
        },
    },
    watch: {
        localSelected(val) {
            this.$emit('update:modelValue', val);
        },
        modelValue(val) {
            this.localSelected = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.creatives-option {
    background: var(--bg);
    border: 1px solid var(--card-border);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    margin: 12px 0;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px solid rgba(15, 23, 42, 0.05);
    }

    &__title {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: var(--accent);
    }

    &__actions {
        /* uses global .is-empty */
        .btn-toggle {
            min-width: 110px;
            padding: 6px 12px;
            border-radius: 8px;
            border: 1px solid var(--card-border);
            background: linear-gradient(90deg, rgba(0, 166, 255, 0.08), rgba(0, 120, 255, 0.06));
            color: var(--accent);
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.15s ease;

            &:hover {
                background: rgba(37, 99, 235, 0.12);
            }

            &:active {
                transform: scale(0.97);
            }
        }
    }

    &__grid {
        display: flex;
        flex-wrap: wrap;
        gap: var(--gap);
        padding: 16px;
        width: 100%;
    }
}

.creative-card {
    background: var(--surface);
    border: 1px solid var(--card-border);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1 1 calc(33.333% - var(--gap));
    max-width: calc(33.333% - var(--gap));
    box-sizing: border-box;

    &__preview {
        position: relative;
        width: 100%;
        height: 180px;
        background: #f9fafb;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }

        video {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            background: #000;
        }

        .creative-card__checkbox {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 18px;
            height: 18px;
            accent-color: #2563eb;
            cursor: pointer;
        }
    }

    &__info {
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 4px;

        .creative-card__name {
            font-size: 14px;
            font-weight: 600;
            color: var(--accent);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .creative-card__size {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: var(--muted);
            img {
                width: 15px;
            }
        }
    }
}

// Responsive styles
@media (max-width: 1024px) {
    .creative-card {
        flex: 1 1 calc(50% - var(--gap));
        max-width: calc(50% - var(--gap));
    }
}

@media (max-width: 768px) {
    .creatives-option {
        &__grid {
            gap: 12px;
            padding: 12px;
        }
    }
    
    .creative-card {
        flex: 1 1 calc(50% - 12px);
        max-width: calc(50% - 12px);
        
        &__preview {
            height: 160px;
        }
    }
}

@media (max-width: 480px) {
    .creatives-option {
        &__grid {
            gap: 10px;
        }
    }
    
    .creative-card {
        flex: 1 1 100%;
        max-width: 100%;
        
        &__preview {
            height: 140px;
        }
    }
}
</style>
